import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {HotelManagementService}  from 'src/app/services/hotel-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { ColorsService } from 'src/app/services/colors.service';

@Component({
  selector: 'app-hotel-management',
  templateUrl: './hotel-management.component.html',
  styleUrls: ['./hotel-management.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class HotelManagementComponent {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  messageTypeCtrl = new FormControl('');
  selectedStateTypes: string[] = [];
  allStateTypes: string[] = [];
  @ViewChild('messageTypeInput') messageTypeInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);

  search:any={searchText:""}
  pagestr:any={
    number:'0',
    size:'10'
  }
  supplierSearch:any={searchText:""}
  sourceSearch:any={searchText:""}
  pageStrSupplier:any={
    number:'0',
    size:'10'
  }
  pageStrSource:any={
    number:'0',
    size:'10'
  }
  
  action:any
  SupplierRegFg!:FormGroup
  settingJson:any
  totalElements:any=0
  menu:any="20px";
  showSupplier:boolean=false;
  showSource:boolean=false;
  showSupplierPopup:boolean=false
  showSourcePopup:boolean=false
  columnsSupplierDisplay: string[] = ['code','name','accountCode','source','status'];
  columnsSourceDisplay: string[] = ['code','name','accountCode','status',];
  SourceRegFg!:FormGroup
  dataSource:any = [];
  supplierData:any = [];
  sourceData:any = [];
  supplierList:any
  expandedElement!: any | null;
  color:any
constructor(private StaticdataService:StaticdataService,private PaymentConfigService:PaymentConfigService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
  private HotelManagementService:HotelManagementService,private userPrivileges: UserPrivilegeService,private ColorsService:ColorsService,
  ){




    this.userPrivileges.userPrivilegesByModule('Hotel').then((privileges:any) => {
      this.privilegesValue(privileges)
    })
    .catch((error:any) => {
    console.error(error); // Handle errors, if any
    });

    this.ColorsService.colors("","").then((color:any) => {
      this.color=color
     })
     .catch((error:any) => {
     });

  
  this.SettingsService.airManageJson().then((data:any) => {
    this.settingJson=data["menu"]
   })
   .catch((error:any) => {
   });

   this.dataFields();
this.onClickSource()
}
privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

dataFields(){

  
  this.SupplierRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "accountCode" : ['',[Validators.required]],
    "source" : ['',[Validators.required]],

  });

  this.SourceRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "accountCode" : [''],

  })
 
  
}

OnClickLink(subMenu:any){
  if(subMenu==="Amadeus"){
  this.router.navigate(["/app/Air-Management/Amadeus"]);}
  else if(subMenu==="User"){
    this.router.navigate(["/app/Air-Management/User-config"]);

  }

}


  backClick(){
window.location.href="/app/settings"
  }


 
 
  
  onClickSupplier(){
    this. showSource=false;
    this.showSupplier=true;

    this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})
    this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

  }
  onClickSource(){
    this.showSupplier=false;
    this.showSource=true;

    this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

  }
  
 
  showBranchId:boolean=false
 

  onAddSupplier(){
    this.action='newSupplier'
    this.showSupplierPopup=true
    this.showSourcePopup=false

  }
  
  onAddSource(){
    this.action='newSource'
    this.showSupplierPopup=false
    this.showSourcePopup=true

  }
  
  closePopup() {
   

    this.showSupplierPopup=false
    this.showSourcePopup=false
    this.dataFields()
  }
 

  

 

 

  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

  
  AddSupplier() {
    this.HotelManagementService.saveSupplier(this.SupplierRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Supplier Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSupplierPopup=false
           this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})

          } else {
            const body : any = res.body;
            this.registerSupplierErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerSupplierErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerSupplierErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Supplier",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Supplier",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchSupplier(){
  
    this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})
  }

  nextSupplierPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getSupplierlist(page)
    //this.getAllUser(page)
  
  }
  getSupplierlist(page:any){

    this.HotelManagementService
    .getSupplierList()
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.supplierData=data;

        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  fileSelected:boolean=false
  selectedFile:any=null
  


  



  AddSource() {
    this.HotelManagementService.saveSource(this.SourceRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Source Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSourcePopup=false
           this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

          } else {
            const body : any = res.body;
            this.registerSourceErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {
if(err.status==400){
  this.toastMsgService.setMsg({msg : "already added this Source & Supplier combination",msgTitle : "Warning", msgType : "W"});

}else{
          this.registerSourceErrorMsg(err.status,err.error);}
        }
      }
    )
  }

  registerSourceErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Source",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Source",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchSource(){
  
    this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})
  }


  nextSourcePage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getSourcelist(page)
    //this.getAllUser(page)
  
  }
  getSourcelist(page:any){

    this.HotelManagementService
    .getSourceList()
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
         

          this.sourceData=data;
      
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
 


 
  rowSupplierClick(element:any){
    this.action='UpdateSupplier'
    this.showSupplierPopup=true
    this.SupplierRegFg=this.fb.group({
      "code" :  [element?.code,[Validators.required]],
      "name" : [element?.name,[Validators.required]],
      "accountCode" : [element?.accountCode,[Validators.required]],
      "source" : [element?.source,[Validators.required]],

    });
  }

rowSourceClick(element:any){
  this.action='updateSource'
  this.showSourcePopup=true
  this.SourceRegFg=this.fb.group({
    "code" :  [element?.code,[Validators.required]],
    "name" : [element?.name,[Validators.required]],
    "accountCode" : [element?.accountCode],
  })
}





  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  onlyNumberSpecialKey(event: any): boolean {
    let charCode = (event.which) ? event.which : event.keyCode;

    // Allow numbers (48-57), plus sign (+ which is 43), minus sign (- which is 45), and colon (: which is 58)
    if (
        (charCode >= 48 && charCode <= 57) ||  // Allow numbers
        charCode === 43 ||  // Allow plus sign (+)
        charCode === 45 ||  // Allow minus sign (-)
        charCode === 58     // Allow colon (:)
    ) {
        return true;
    }

    // Prevent default for other characters
    return false;
}
  disable=false



  updateSupplier() {
    this.HotelManagementService.updateSupplier(this.SupplierRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Supplier Updated Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSupplierPopup=false
           this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})

          } else {
            const body : any = res.body;
            this.registerSupplierErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerSupplierErrorMsg(err.status,err.error);
        }
      }
    )
  }

  updateSupplierErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Update Supplier",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to Update Supplier",msgTitle:  "Warning", msgType : "W"});
    } 
  }


  updateSource() {
    this.HotelManagementService.updateSource(this.SourceRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Source Updated Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSourcePopup=false
           this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

          } else {
            const body : any = res.body;
            this.updateSourceErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {
  // this.toastMsgService.setMsg({msg : "already added this Source & Supplier combination",msgTitle : "Warning", msgType : "W"});

          this.updateSourceErrorMsg(err.status,err.error);}
        
      }
    )
  }

  updateSourceErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Update Source",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to Update Source",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
}
